import React, { Fragment, useState, useEffect, useRef, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { NavLink, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { notification } from '../StyleShare';
import MenuPermission from './Views';

import { getMenuListMenu } from './Controllers/menuApis';

import './Asset/navbar.scss';

const NavbarPermission = ({ children, token }) => {
    const uploadImageDomain = process.env.REACT_APP_URL_API_UPLOAD;

    const header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
        Authorization: token,
    };

    // configure data

    const [menus, setDataMenus] = useState([]);
    const [openSubmenuId, setOpenSubmenuId] = useState(null);
    const menuItemRefs = useRef({});
    const [dropdownRect, setDropdownRect] = useState(null);
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 768);
    const hoverCloseTimeout = useRef(null);

    // configure data

    // // call api

    const handleGetListMenu = async (data) => {
        try {
            const result = await getMenuListMenu(data, header);
            if (result.status === 200) {
                setDataMenus(result.data);
            } else {
                toast.error(result.message, notification);
            }
        } catch (error) {
            console.log(error);
            toast.warning('Hệ thống đang bảo trì.', notification);
        }
    };

    // // call api

    const location = useLocation();

    useEffect(() => {
        if (token) {
            const currentURL = window.location.href;
            const url = new URL(currentURL);
            const link = url.origin;

            handleGetListMenu({
                domain: link,
            });
        }
    }, [token]);

    // Đóng submenu khi chuyển trang
    useEffect(() => {
        setOpenSubmenuId(null);
    }, [location.pathname]);

    // Đóng submenu khi click ra ngoài (không đóng khi click vào dropdown portal)
    useEffect(() => {
        if (openSubmenuId == null) return;
        const handleClickOutside = (e) => {
            if (!e.target.closest('.menu-container') && !e.target.closest('.menu-sub-portal')) {
                setOpenSubmenuId(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [openSubmenuId]);

    // Cập nhật vị trí dropdown khi mở hoặc scroll/resize
    useLayoutEffect(() => {
        if (openSubmenuId == null) {
            setDropdownRect(null);
            return;
        }
        const updateDropdownRect = () => {
            const el = menuItemRefs.current[openSubmenuId];
            if (el) setDropdownRect(el.getBoundingClientRect());
            else setDropdownRect(null);
        };
        updateDropdownRect();
        const onScrollOrResize = () => updateDropdownRect();
        window.addEventListener('scroll', onScrollOrResize, true);
        window.addEventListener('resize', onScrollOrResize);
        return () => {
            window.removeEventListener('scroll', onScrollOrResize, true);
            window.removeEventListener('resize', onScrollOrResize);
        };
    }, [openSubmenuId]);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const openMenu = menus.find((m) => m.id === openSubmenuId);

    return (
        <header className='mainHeader clearfix posR ng-scope'>
            <section className='container-fluid d-flex align-items-center justify-content-between'>
                <a href='/' style={{ height: '50px' }} className='dpib ovh logo wrapper-logo ng-scope'>
                    <img
                        style={{ width: '140px', marginTop: '5px' }}
                        src={require('../../../assets/images/BingxueLogo.png')}
                        alt='logo'
                    />
                </a>
                <div className='d-flex align-items-center '>
                    <MenuPermission token={token} header={header} />
                    {children}
                </div>
            </section>
            <nav className='menu-container w100 fll uln off-menu'>
                <section className='container-fluid'>
                    <div className='menu-custom'>
                        {menus.map((menu) => {
                            const isMenuActive = () => {
                                let parentMenuActive = false;

                                let checkMenuActive = [];

                                if (menu.subMenus && menu.subMenus.length > 0) {
                                    const listCheck = menu.subMenus.map((subMenu) => {
                                        if (subMenu.subMenus && subMenu.subMenus.length > 0) {
                                            return subMenu.subMenus.some((sub) => {
                                                return location.pathname.startsWith(sub.path);
                                            });
                                        } else {
                                            return location.pathname === subMenu.path;
                                        }
                                    });
                                    checkMenuActive.push(listCheck.includes(true));
                                }

                                parentMenuActive = checkMenuActive.includes(true);

                                return {
                                    rootMenuActive: parentMenuActive,
                                    parentMenuActive,
                                };
                            };

                            const menuActive = isMenuActive();

                            return (
                                <Fragment key={menu.id}>
                                    {menu.subMenus && menu.subMenus.length > 0 ? (
                                        <div
                                            className={`menu-item ${openSubmenuId === menu.id ? 'is-open' : ''}`}
                                            ref={(el) => {
                                                menuItemRefs.current[menu.id] = el;
                                            }}
                                            onMouseEnter={() => {
                                                if (isMobile) return;
                                                if (hoverCloseTimeout.current) {
                                                    clearTimeout(hoverCloseTimeout.current);
                                                    hoverCloseTimeout.current = null;
                                                }
                                                setOpenSubmenuId(menu.id);
                                            }}
                                            onMouseLeave={() => {
                                                if (isMobile) return;
                                                hoverCloseTimeout.current = setTimeout(() => {
                                                    setOpenSubmenuId(null);
                                                    hoverCloseTimeout.current = null;
                                                }, 150);
                                            }}
                                        >
                                            <a
                                                className={`menu-item-content ${
                                                    menuActive.rootMenuActive ? 'active' : ''
                                                }`}
                                                href='#'
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setOpenSubmenuId((prev) => (prev === menu.id ? null : menu.id));
                                                }}
                                            >
                                                {menu.iconUrl ? (
                                                    <img src={`${uploadImageDomain}${menu.iconUrl}`} alt='iconmenu' />
                                                ) : (
                                                    <i className='mdi mdi-account-box'></i>
                                                )}
                                                {menu.name}
                                            </a>
                                            <div className='menu-sub' style={openSubmenuId === menu.id ? { display: 'none' } : undefined}>
                                                {menu.subMenus.map((subMenu) => {
                                                    return subMenu.subMenus && subMenu.subMenus.length ? (
                                                        <div key={subMenu.id} className='child-menu-item'>
                                                            <a className={menuActive.parentMenuActive ? 'active' : ''}>
                                                                {subMenu.iconUrl ? (
                                                                    <img
                                                                        src={`${uploadImageDomain}${subMenu.iconUrl}`}
                                                                        alt='iconmenu'
                                                                    />
                                                                ) : (
                                                                    <i className='mdi mdi-account-box'></i>
                                                                )}
                                                                {subMenu.name}
                                                            </a>
                                                            <div className='menu-last'>
                                                                {subMenu.subMenus.map((menuLastItem) => {
                                                                    return (
                                                                        <div
                                                                            key={subMenu.id}
                                                                            className='menu-last-item'
                                                                        >
                                                                            <NavLink
                                                                                exact
                                                                                to={menuLastItem.path || '/'}
                                                                                activeClassName='active'
                                                                            >
                                                                                {menuLastItem.iconUrl ? (
                                                                                    <img
                                                                                        src={`${uploadImageDomain}${menuLastItem.iconUrl}`}
                                                                                        alt='iconmenu'
                                                                                    />
                                                                                ) : (
                                                                                    <i className='mdi mdi-account-box'></i>
                                                                                )}
                                                                                {menuLastItem.name}
                                                                            </NavLink>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div key={subMenu.id} className='child-menu-item'>
                                                            <NavLink
                                                                to={subMenu.path || '/'}
                                                                activeClassName='active'
                                                                exact
                                                            >
                                                                {subMenu.iconUrl ? (
                                                                    <img
                                                                        src={`${uploadImageDomain}${subMenu.iconUrl}`}
                                                                        alt='iconmenu'
                                                                    />
                                                                ) : (
                                                                    <i className='mdi mdi-account-box'></i>
                                                                )}
                                                                {subMenu.name}
                                                            </NavLink>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ) : (
                                        // active class
                                        <div className='menu-item '>
                                            <NavLink to={menu.path || '/'} activeClassName='active' exact>
                                                {menu.iconUrl ? (
                                                    <img src={`${uploadImageDomain}${menu.iconUrl}`} alt='iconmenu' />
                                                ) : (
                                                    <i className='mdi mdi-account-box'></i>
                                                )}
                                                {menu.name}
                                            </NavLink>
                                        </div>
                                    )}
                                </Fragment>
                            );
                        })}
                    </div>
                </section>
            </nav>
            {openSubmenuId != null &&
                openMenu &&
                dropdownRect &&
                createPortal(
                    <div
                        className='menu-sub-portal'
                        style={{
                            position: 'fixed',
                            left: Math.max(8, Math.min(dropdownRect.left, window.innerWidth - 296)),
                            ...(isMobile
                                ? {
                                      top: dropdownRect.bottom,
                                      bottom: 'auto',
                                      maxHeight: Math.min(window.innerHeight - dropdownRect.bottom - 8, window.innerHeight * 0.7),
                                  }
                                : {
                                      top: dropdownRect.bottom,
                                      bottom: 'auto',
                                      maxHeight: '85vh',
                                  }),
                            minWidth: 280,
                            overflowY: 'auto',
                            padding: '12px 0',
                            backgroundColor: '#0078b6',
                            borderRadius: 4,
                            zIndex: 10000000,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseEnter={() => {
                            if (hoverCloseTimeout.current) {
                                clearTimeout(hoverCloseTimeout.current);
                                hoverCloseTimeout.current = null;
                            }
                        }}
                        onMouseLeave={() => {
                            hoverCloseTimeout.current = setTimeout(() => {
                                setOpenSubmenuId(null);
                                hoverCloseTimeout.current = null;
                            }, 150);
                        }}
                    >
                        {openMenu.subMenus.flatMap((subMenu) =>
                            subMenu.subMenus && subMenu.subMenus.length
                                ? subMenu.subMenus.map((menuLastItem) => (
                                      <div key={menuLastItem.id} className='menu-sub-portal-item'>
                                          <NavLink
                                              exact
                                              to={menuLastItem.path || '/'}
                                              activeClassName='active'
                                              onClick={() => setOpenSubmenuId(null)}
                                          >
                                              {menuLastItem.iconUrl ? (
                                                  <img
                                                      src={`${uploadImageDomain}${menuLastItem.iconUrl}`}
                                                      alt='iconmenu'
                                                  />
                                              ) : (
                                                  <i className='mdi mdi-account-box'></i>
                                              )}
                                              {menuLastItem.name}
                                          </NavLink>
                                      </div>
                                  ))
                                : [
                                      <div key={subMenu.id} className='menu-sub-portal-item'>
                                          <NavLink
                                              to={subMenu.path || '/'}
                                              activeClassName='active'
                                              exact
                                              onClick={() => setOpenSubmenuId(null)}
                                          >
                                              {subMenu.iconUrl ? (
                                                  <img
                                                      src={`${uploadImageDomain}${subMenu.iconUrl}`}
                                                      alt='iconmenu'
                                                  />
                                              ) : (
                                                  <i className='mdi mdi-account-box'></i>
                                              )}
                                              {subMenu.name}
                                          </NavLink>
                                      </div>,
                                  ]
                        )}
                    </div>,
                    document.body
                )}
        </header>
    );
};

export default NavbarPermission;
